export type AssociatedArray = { [index: string]: any }

export const isAssociatedArray = (obj: AssociatedArray): boolean => {
  return obj instanceof Object && !(obj instanceof Array)
}

export const isEmptyAssociatedArray = (obj: AssociatedArray | string) => {
  return !Object.keys(obj).length
}

export const isEqualArray = (array1: any[], array2: any[]) => {
  let i = array1.length
  if (i != array2.length) {
    return false
  }

  while (i--) {
    if (isAssociatedArray(array1[i])) {
      if (JSON.stringify(array1[i]) !== JSON.stringify(array2[i])) {
        return false
      }
    } else if (Array.isArray(array1[i])) {
      if (!Array.isArray(array2[i]) || !isEqualArray(array1[i], array2[i])) {
        return false
      }
    } else if (array1[i] !== array2[i]) {
      return false
    }
  }
  return true
}

export const filterDefined = <T extends { [index: string]: any }>(obj: T): T => {
  let filtered: { [index: string]: any } = {}
  Object.keys(obj).filter((key: string) => {
    if (obj[key] != undefined && obj[key] != null) {
      filtered[key] = obj[key]
    }
  })
  return filtered as T
}

export const filterBooleanToNumber = (obj: { [index: string]: any }): { [index: string]: any } => {
  let filtered: { [index: string]: any } = {}
  Object.keys(obj).filter((key: string) => {
    if (typeof obj[key] === 'boolean') {
      filtered[key] = obj[key] ? 1 : 0
    } else if (Array.isArray(obj[key])) {
      filtered[key] = obj[key].map((value: any) =>
        typeof value === 'boolean' ? (value ? 1 : 0) : value
      )
    } else {
      filtered[key] = obj[key]
    }
  })
  return filtered
}

export const filterArrayDiffs = <T extends { [index: string]: any }>(
  objOld: { [index: string]: any },
  objNew: { [index: string]: any }
): T => {
  let filtered: { [index: string]: any } = {}
  Object.keys(objNew).filter((key: string) => {
    if (isAssociatedArray(objNew[key])) {
      // const diffs = objOld && objOld[key] ? filterArrayDiffs(objOld[key], objNew[key]) : objNew[key]
      // if (!isEmptyAssociatedArray(diffs)) {
      //   filtered[key] = diffs
      // }
      if (!objOld || !objOld[key] || JSON.stringify(objOld[key]) !== JSON.stringify(objNew[key])) {
        filtered[key] = objNew[key]
      }
    } else if (Array.isArray(objNew[key])) {
      if (!isEqualArray(objOld[key] ?? [], objNew[key])) {
        filtered[key] = objNew[key]
      }
    } else if (objOld[key] != objNew[key]) {
      filtered[key] = objNew[key]
    }
  })
  return filtered as T
}

export const replaceArrayWithIndex = <T,>(values: T[], value: T, index: number) => {
  return [...values.slice(0, index), value, ...values.slice(index + 1)]
}

export const filterDuplication = <T,>(array: T[]) => {
  return Array.from(new Set(array))
}

export const filterArrayWithIndex = <T,>(values: T[], index: number) => {
  return [...values.slice(0, index), ...values.slice(index + 1)]
}

export const filterNotEmpty = (obj: { [index: string]: any }): { [index: string]: any } => {
  let filtered: { [index: string]: any } = {}
  Object.keys(obj).filter((key: string) => {
    if (obj[key] && (!Array.isArray(obj[key]) || obj[key].length > 0)) {
      filtered[key] = obj[key]
    }
  })
  return filtered
}
